import { lazy } from 'react';

const AprrovedCertificationVerifierConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/verifier/consult/aprroved-certification',
			component: lazy(() => import('./AprrovedCertificationContainer'))
		}
	]
};

export default AprrovedCertificationVerifierConfig;

